import { styled } from "@mui/material/styles";

type ComponentType = "div" | "span";

export const ColoredOddRow = (component: ComponentType) => styled(component)(({ theme }) => ({
    "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
}));

export const FullHeight: React.CSSProperties = {
    height: "100%",
    minHeight: "100vh"
};
